/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const IndexSnapshotSaver = {
  _interval: 20,
  _lastValue: {},
  _indexNames: [],

  initialize(indexNames, preloadedCookies, path) {
    if (preloadedCookies == null) { preloadedCookies = []; }
    this._indexNames = indexNames;
    this._lastValue = this._readCookies();
    this._setPreloadedCookies(preloadedCookies, path);
    return this;
  },

  startSaving() {
    return setInterval(_.bind(this._checkCookies, this), this._interval * 1000);
  },

  _setPreloadedCookies(preloadedCookies, path) {
    return _.each(preloadedCookies, values => $.cookie(values[0], values[1], { path }));
  },

  _cookieChanged(name) {
    return this._findLastCookieValue(name).value !== this._readSingleCookie(name);
  },

  _findLastCookieValue(name) {
    return _.find(this._lastValue, { name });
  },

  _readCookies() {
    return _.map(this._indexNames, name => {
      return { name, value: this._readSingleCookie(name) };
    });
  },

  _readSingleCookie(name) {
    if ($.cookie(name)) {
      return $.cookie(name).toString();
    } else {
      return null;
    }
  },

  _setLastCookieValue(name, value) {
    return _.find(this._lastValue, { name }).value = value;
  },

  _checkCookies() {
    return _.each(this._indexNames, name => {
      const value = this._readSingleCookie(name);
      if (this._cookieChanged(name) && value) {
        return this._sendSave(name, value);
      }
    });
  },

  _sendSave(name, value) {
    const data = {
      index_snapshot: {
        name,
        value
      }
    };

    return $.ajax({
      url: '/index_snapshots.json',
      data: JSON.stringify(data),
      contentType: "application/json",
      dataType: 'json',
      method: 'POST',
      success: response => {
        if (response.status === 'success') {
          return this._setLastCookieValue(name, value);
        } else {
          return this._setLastCookieValue(name, null);
        }
      }
    });
  }
};

module.exports = IndexSnapshotSaver;
